// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2_fNq","footer-info":"Footer_footer-info__D-IXs","github":"Footer_github__3KLfS","linkedin":"Footer_linkedin__3ff7b","website":"Footer_website__VxLZk"};